module.exports = __webpack_public_path__ + "img/undraw_meditation_re_gll0.7c241140.svg";